<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <div class="align-center">
      <span *ngIf="user.logo.url">
        <img [src]="user.logo.url" alt="{{ user.first_name }}" class="img-circle" />
      </span>
      <span *ngIf="!user.logo.url" class="default-img img-circle"></span>
    </div>
    <br />

    <div class="ticket">
      <div class="ticket-table ticket-table-no-border">
        <div class="row t-t-row">
          <div class="col-sm-5 t-t-label">{{ 'NAME' | translate }}</div>
          <div class="col-sm-7">{{ user.first_name }} {{ user.last_name }}</div>
        </div>
        <div class="row t-t-row">
          <div class="col-sm-5 t-t-label">{{ 'COUNTRY' | translate }}</div>
          <div class="col-sm-7">{{ user.country.country_code }} {{ user.country.name }}</div>
        </div>
        <div class="row t-t-row">
          <div class="col-sm-5 t-t-label">{{ 'EMAIL_ADDRESS' | translate }}</div>
          <div class="col-sm-7">{{ user.email }}</div>
        </div>
        <div class="row t-t-row">
          <div class="col-sm-5 t-t-label">{{ 'TELEPHONE' | translate }}</div>
          <div class="col-sm-7">{{ user.phone }} {{ user.mobile ? ' / ' + user.mobile : '' }}</div>
        </div>
        <div class="row t-t-row">
          <div class="col-sm-5 t-t-label">{{ 'STATUS' | translate }}</div>
          <div class="col-sm-7">
            <span class="label label-success" *ngIf="user.activated_at">
              <i class="fa fa-check"></i> {{ 'ACCOUNT_CONFIRMED' | translate }}
            </span>
            <span class="label label-warning" *ngIf="!user.activated_at">
              <i i class="fa fa-clock-o"></i> {{ 'PENDING_ACTIVATION' | translate }}
            </span>

            <span
              style="margin-left: 6px"
              class="label"
              ng-class="user.status === 'active' ? ' label-primary' : ' label-default'"
            >
              {{ user.status === 'active' ? ('ACTIVE' | translate) : ('INACTIVE' | translate) }}
            </span>
          </div>
        </div>
      </div>

      <hr />
      <div class="align-right small text-muted">
        {{ 'CREATED_AT' | translate }}:
        {{ user.created_at | dateFormat: dateDisplay }}
      </div>
    </div>
  </div>
  <div class="dialog-actions dialog-actions-fixed">
    <!-- Close -->
    <span class="btn btn-lg" (click)="close()">
      <i class="fa fa-close"></i> {{ 'CLOSE' | translate }}
    </span>
  </div>
</div>
